// @flow

import React, { Fragment } from 'react'

import Hero from 'components/Hero'
import Storitve from 'components/Storitve'
import Koraki from 'components/Koraki'
import Pristop from 'components/Pristop'
import Tehnologije from 'components/Tehnologije'
import Kontakt from 'components/Kontakt'

const IndexPage = () => (
  <Fragment>
    <Hero />
    <Storitve />
    <Koraki />
    <Pristop />
    <Tehnologije />
    <Kontakt />
  </Fragment>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js